<template>
  <div class="PASSWORD-FORGOT">
    <forgot-password-form :default-email="email"/>
    Already have an account?
    <router-link
        :to="{
          name: 'login',
          query: {
            email,
            redirectTo: this.redirectTo
          },
          params: {
            proLogin: this.proLogin
          }
        }"
        class="link"
        selenium="login-forgot-password-link">
      Sign in with password.
    </router-link>
  </div>
</template>

<script>
import ForgotPasswordForm from '@/components/ForgotPasswordForm';

export default {
  name: 'password-forgot',
  components: {
    ForgotPasswordForm,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    redirectTo: {
      type: [Object, String],
      default: '',
    },
    proLogin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    redirect () {
      const redirectToOrLogin = this.redirectTo ? this.redirectTo : '/login';
      this.$router.push({ name: redirectToOrLogin });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .PASSWORD-FORGOT {
    text-align: center;
    @include margin(6 auto);
  }
</style>
